import { render, staticRenderFns } from "./ExportShipments.vue?vue&type=template&id=8f940b7a&scoped=true&"
import script from "./ExportShipments.vue?vue&type=script&lang=ts&"
export * from "./ExportShipments.vue?vue&type=script&lang=ts&"
import style0 from "./ExportShipments.vue?vue&type=style&index=0&id=8f940b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f940b7a",
  null
  
)

export default component.exports